module.exports = __webpack_public_path__ + "static/media/3.86a14d2c.jpg";